import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { ForumOrderField } from "messaging/forums/_api/queries/forum-query";
import { z } from "zod";

export type ForumOrderParametersProps = z.infer<typeof ForumOrderSchema.ForumOrderZ>;

export default class ForumOrderSchema {
  public static readonly ForumOrderZ = z
    .object({
      get orderDir() {
        return z.enum(Object.keys(OrderDirection) as [keyof typeof OrderDirection]).optional();
      },
      get orderBy() {
        return z.enum(Object.keys(ForumOrderField) as [keyof typeof ForumOrderField]).optional();
      },
    })
    .optional();

  public static create(values: ForumOrderParametersProps): ForumOrderParametersProps {
    return parseOrThrow(ForumOrderSchema.ForumOrderZ, values, {
      logError: true,
      schemaName: "ForumOrderSchema",
      operation: "create",
      payloadSample: values,
    });
  }
}
